import { render, staticRenderFns } from "./SpecialBiwako.vue?vue&type=template&id=bd4105fa"
import script from "./SpecialBiwako.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako.vue?vue&type=style&index=0&id=bd4105fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports